import { useMutation } from "react-query";
import { useToasts } from "react-toast-notifications";

import api from "../../../api";
import { getErrorMessage } from "utils/error";

const unassignSeatsService = async ({
  teamId,
  userIds,
}: {
  teamId: number;
  userIds: number[];
}) => {
  const { data } = await api.delete(`profile/teams/${teamId}/users`, {
    data: {
      user_id: userIds,
    },
  });
  return data;
};

export const useUnassignSeatsMutation = () => {
  const { addToast } = useToasts();

  // No success toast here. The DELETE resolving is not the end of the job — the
  // caller still refreshes the list and keeps the modal up while it does, so
  // announcing success from here contradicts a modal that is visibly still
  // working. The caller reports success once everything has settled.
  const [mutate, { ...mutationProps }] = useMutation(unassignSeatsService, {
    onError: (error: unknown) => {
      // The response interceptor already reduces API bodies and network
      // failures to a string, so report what actually went wrong. A list that
      // went stale because someone else removed the user, and a dropped
      // connection, are different problems and were both reading as the same
      // "contact support" line.
      addToast(
        getErrorMessage(
          error,
          "Failed to unassign seats, please contact support for assistance.",
        ),
        { appearance: "error" },
      );
    },
  });
  return {
    mutate,
    ...mutationProps,
  };
};
